
import Ordc01CompleteComponent from '@/components/ordc01/Ordc01CompleteComponent.vue';
import Ordc01ErrorComponent from '@/components/ordc01/Ordc01ErrorComponent.vue';
import { JpCoBenefitoneBsdpBffPresentationResponseConfirmPayPostResponse } from '@/openapi/order';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: {
    Ordc01CompleteComponent,
    Ordc01ErrorComponent,
  },
})
export default class Ordc01View extends Vue {
  @Prop({ type: String, required: true })
  status!: 'Success' | 'Fail';

  @Prop({ type: Object, required: false })
  confirmPayPostResponse!: JpCoBenefitoneBsdpBffPresentationResponseConfirmPayPostResponse;
}
